import { render, staticRenderFns } from "./CTranslatorModal.vue?vue&type=template&id=646eea8e&"
import script from "./CTranslatorModal.vue?vue&type=script&lang=js&"
export * from "./CTranslatorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports